/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the stopwatch work offline?`)
};

const es_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El cronómetro funciona sin conexión?`)
};

const de_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioniert die Stoppuhr offline?`)
};

const nl_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkt de stopwatch offline?`)
};

const fr_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le chronomètre fonctionne-t-il hors ligne ?`)
};

const it_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il cronometro funziona offline?`)
};

const pt_br2_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cronômetro funciona offline?`)
};

const pt_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O cronómetro funciona offline?`)
};

const ja_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストップウォッチはオフラインでも使えますか？`)
};

const zh_timer_stopwatch_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秒表离线时能用吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq3_q", locale)
	if (locale === "en") return en_timer_stopwatch_faq3_q(inputs)
	if (locale === "es") return es_timer_stopwatch_faq3_q(inputs)
	if (locale === "de") return de_timer_stopwatch_faq3_q(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq3_q(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq3_q(inputs)
	if (locale === "it") return it_timer_stopwatch_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq3_q(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq3_q(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq3_q(inputs)
	return zh_timer_stopwatch_faq3_q(inputs)
};